import React from "react";
import "./../../UaeAttestation/UaeAbout/UaeAbout.css";
import qatarAbout from "./../../../../vid_img/qatarAbout.jpg";
const SaudiAboutMain = () => {
  return (
    <div className="uaeAboutUsMainContainer">
      <div className="uaeAboutUsMainContent">
        <ul>
          <li>
            Being the cradle of Islam, Saudi Arabia is one the premier
            pilgrimage destinations in the world. It is the largest economy in
            the Middle-East and the 18th largest in the world. Saudi Arabia is
            one of the largest petroleum products exporters in the world.
          </li>
          <li>
            People visiting Saudi Arabia need to have all their documents and
            certificates attested by different authorities of Saudi Arabia, to
            ensure that their visit is with minimal hassle.
          </li>
          <li>
            You do not have to go out of Bengaluru to get your certificates and
            documents attested by different authorities of Saudi Arabia. You can
            get them attested in Bengaluru itself, approaching our friendly and
            helpful professionals at Goodway Attesting.
          </li>
          <li>
            You need to get your documents attested by the Embassy of Saudi
            Arabia to as part of your travel visa application process. Goodway
            Attestation makes your task simpler by getting your documents
            attested by the Embassy of Saudi Arabia, in Bengaluru itself. Be
            assured that the fees for attesting your papers are nominal!
          </li>
          <li>
            Saudi Arabia has an extreme climate during summer, thus people
            travelling there during that season need to have important
            certificates or documents such as medical and fitness certificate.
            For those travelling to Saudi Arabia for higher studies, educational
            certificates and other relevant documents are important. The
            professionals at Goodway Attestation in Bengaluru help you with
            attestation for Saudi Arabia at nominal costs.
          </li>
          <li>
            If you need to get your certificates, documents, and others attested
            by different authorities of Qatar,, you need not go out of
            Bengaluru. You just need to get the job done by the professionals at
            Goodway Attestation, in Bengaluru.
          </li>
        </ul>
      </div>
      <div className="uaeAboutUsMainContentImg">
        <img src={qatarAbout} alt="qatarAbout" />
      </div>
    </div>
  );
};

export default SaudiAboutMain;
